module.exports = __webpack_public_path__ + "media/images/icons/ic-check-95e196d6b411c92b0428a86c07620f70.svg";